<template>
  <div id="app">
    <nav class="navbar">
      <div class="nav-container">
        <router-link to="/" class="nav-brand">
          <img class="brand-logo" src="./assets/icon.png" alt="cloudSend">
          <span class="brand-text">cloud<em>Send</em></span>
        </router-link>
        <ul class="nav-menu" :class="{ active: menuOpen }">
          <li><router-link to="/" exact @click.native="closeMenu">首页</router-link></li>
          <li><router-link to="/features" @click.native="closeMenu">功能特性</router-link></li>
          <li><router-link to="/guide" @click.native="closeMenu">使用指南</router-link></li>
          <li><router-link to="/download" @click.native="closeMenu">下载与赞助</router-link></li>
          <li class="nav-menu-github">
            <a href="https://github.com/dellevin/cloudServer" target="_blank" rel="noopener">GitHub</a>
          </li>
        </ul>
        <div class="nav-right">
          <a class="nav-github" href="https://github.com/dellevin/cloudServer" target="_blank" rel="noopener" aria-label="GitHub 仓库">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.11.79-.25.79-.55 0-.27-.01-1.17-.02-2.12-3.2.7-3.88-1.36-3.88-1.36-.52-1.33-1.28-1.68-1.28-1.68-1.04-.71.08-.7.08-.7 1.15.08 1.76 1.18 1.76 1.18 1.03 1.76 2.69 1.25 3.35.96.1-.75.4-1.25.72-1.54-2.55-.29-5.24-1.28-5.24-5.69 0-1.26.45-2.28 1.18-3.09-.12-.29-.51-1.46.11-3.05 0 0 .96-.31 3.15 1.18a10.9 10.9 0 0 1 5.74 0c2.19-1.49 3.15-1.18 3.15-1.18.62 1.59.23 2.76.11 3.05.73.81 1.18 1.83 1.18 3.09 0 4.42-2.7 5.4-5.27 5.68.41.36.78 1.05.78 2.13 0 1.54-.01 2.78-.01 3.16 0 .3.2.67.8.55A11.52 11.52 0 0 0 23.5 12C23.5 5.65 18.35.5 12 .5z"/></svg>
          </a>
          <router-link to="/download" class="btn btn-primary nav-cta">下载</router-link>
          <div class="nav-toggle" :class="{ active: menuOpen }" @click="toggleMenu">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </nav>
    <main class="main-content">
      <router-view/>
    </main>
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-brand">
          <img class="brand-logo" src="./assets/icon.png" alt="cloudSend">
          <span>cloudSend</span>
        </div>
        <p class="footer-desc">跨网络的文件互传与设备互联 · 服务器零存储 · 端到端加密</p>
        <div class="footer-links">
          <router-link to="/">首页</router-link>
          <router-link to="/features">功能</router-link>
          <router-link to="/guide">指南</router-link>
          <router-link to="/download">下载</router-link>
        </div>
        <div class="footer-links">
          <a href="https://github.com/dellevin/cloudServer" target="_blank" rel="noopener">GitHub 开源</a>
          <a href="https://www.iletter.top/" target="_blank" rel="noopener">作者简介</a>
          <a href="https://blog.iletter.top" target="_blank" rel="noopener">作者博客</a>
        </div>
        <p class="copyright">© 2026 cloudSend. All rights reserved.</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      menuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    closeMenu() {
      this.menuOpen = false
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --color-bg: #f7f8f7;
  --color-bg-raised: #ffffff;
  --color-bg-subtle: #eff1ef;
  --color-text: #171918;
  --color-text-secondary: #576057;
  --color-text-muted: #97a097;
  --color-border: #e5e7e3;
  --color-border-strong: #d2d5d0;
  --color-accent: #07c160;
  --color-accent-strong: #06a653;
  --color-accent-soft: #e8f8ef;
  --color-ok: #07c160;
  --shadow-card: none;
  --shadow-raised: 0 1px 2px rgba(23, 25, 24, 0.05), 0 20px 44px -14px rgba(23, 25, 24, 0.16);
  --font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  --font-mono: 'Cascadia Code', 'Fira Code', Consolas, monospace;
}

body {
  font-family: var(--font-family);
  color: var(--color-text);
  background-color: var(--color-bg);
  line-height: 1.65;
  -webkit-font-smoothing: antialiased;
}

::selection {
  background: var(--color-accent-soft);
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Navbar */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(246, 247, 246, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--color-border);
  z-index: 1000;
}

.nav-container {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 17px;
  font-weight: 650;
  letter-spacing: -0.01em;
  text-decoration: none;
  color: var(--color-text);
}

.brand-logo {
  width: 26px;
  height: 26px;
  border-radius: 7px;
}

.brand-text em {
  font-style: normal;
  color: var(--color-accent);
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 30px;
  align-items: center;
}

.nav-menu a {
  text-decoration: none;
  color: var(--color-text-secondary);
  font-size: 14px;
  font-weight: 500;
  transition: color 0.15s;
}

.nav-menu a:hover {
  color: var(--color-text);
}

.nav-menu a.router-link-active {
  color: var(--color-text);
  font-weight: 600;
}

.nav-menu-github {
  display: none;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nav-cta {
  padding: 7px 18px;
  font-size: 13px;
  border-radius: 7px;
}

.nav-github {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  color: var(--color-text-secondary);
  transition: color 0.15s, background 0.15s;
}

.nav-github:hover {
  color: var(--color-text);
  background: var(--color-bg-subtle);
}

.nav-toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
  padding: 5px;
}

.nav-toggle span {
  width: 22px;
  height: 2px;
  background: var(--color-text);
  transition: all 0.25s ease;
  border-radius: 1px;
}

.nav-toggle.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.nav-toggle.active span:nth-child(2) {
  opacity: 0;
}

.nav-toggle.active span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

/* Main Content */
.main-content {
  flex: 1;
  padding-top: 60px;
}

/* Footer */
.footer {
  background: #131a16;
  padding: 64px 24px 40px;
}

.footer-content {
  max-width: 1120px;
  margin: 0 auto;
  text-align: center;
}

.footer-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 650;
  color: #f2f5f2;
  margin-bottom: 10px;
}

.footer-desc {
  color: #8b978d;
  font-size: 13px;
  margin-bottom: 26px;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 28px;
  margin-bottom: 14px;
}

.footer-links a {
  color: #a8b3aa;
  text-decoration: none;
  font-size: 13px;
  transition: color 0.15s;
}

.footer-links a:hover {
  color: #2bd47e;
}

.copyright {
  color: #5c6860;
  font-size: 12px;
  margin-top: 24px;
}

/* Shared section helpers */
.section {
  padding: 88px 24px;
}

.container {
  max-width: 1120px;
  margin: 0 auto;
}

.section-tag {
  display: block;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.14em;
  color: var(--color-accent);
  margin-bottom: 14px;
}

.section-title {
  font-size: 34px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
  margin-bottom: 14px;
}

.section-subtitle {
  font-size: 16px;
  color: var(--color-text-secondary);
  max-width: 620px;
  margin: 0 auto 52px;
}

.text-gradient {
  color: var(--color-accent);
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 26px;
  border-radius: 9px;
  font-size: 14.5px;
  font-weight: 550;
  text-decoration: none;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  cursor: pointer;
  border: none;
}

.btn-primary {
  background: var(--color-accent);
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(7, 193, 96, 0.35);
}

.btn-primary:hover {
  background: var(--color-accent-strong);
}

.btn-ghost {
  background: var(--color-bg-raised);
  color: var(--color-text);
  border: 1px solid var(--color-border-strong);
}

.btn-ghost:hover {
  background: var(--color-bg-subtle);
}

.icon svg {
  display: block;
}

/* Responsive */
@media (max-width: 768px) {
  .nav-menu {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    background: var(--color-bg-raised);
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 24px 20px;
    gap: 16px;
    border-bottom: 1px solid var(--color-border);
    transform: translateY(-8px);
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease;
  }

  .nav-menu.active {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }

  .nav-menu-github {
    display: block;
  }

  .nav-github,
  .nav-cta {
    display: none;
  }

  .nav-toggle {
    display: flex;
  }

  .section {
    padding: 60px 20px;
  }

  .section-title {
    font-size: 27px;
  }

  .footer-links {
    flex-wrap: wrap;
    gap: 18px;
  }
}
</style>
